// Map from cart contents to the richer model used for editing
// We may be restoring from an old kit that is no longer valid in the current catalog (for reordering old
// kits), so we only overwrite the default state with data we've validated against the catalog.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RnaCishAmplifierComponent, RnaFishBuffersComponent, SimpleProbeSetComponent } from "../rna-fish/KitModel";
import { probeKitToProbeFormState } from "../rna-fish/RnaFishKitToFormState";
import { defaultBufferState, defaultProbeSetState } from "../rna-fish/EditKitForm";
import { defaultAmpState } from "./ManualProConsumerKitForm";
export var manualProKitToConsumerFormState = function (catalog, bundles) {
    var _a, _b;
    var kit = (_a = bundles.kits.find(function (k) { return k.channel === 1; })) !== null && _a !== void 0 ? _a : (function () { throw new Error("Kit not found"); })();
    var psc = kit.probeSetComponents.find(function (p) { return p.index === 1 && p instanceof SimpleProbeSetComponent; });
    var amp = kit.amplifierComponents.find(function (c) { return c.index === 1 && c instanceof RnaCishAmplifierComponent; });
    var manualBuf = kit.buffersComponents.find(function (b) { return b.index === 1 && b instanceof RnaFishBuffersComponent; });
    var chromogenComponent = kit.chromogenComponents.find(function (c) { return c.index === 1; });
    // probe set
    var probeSetEnabled = false;
    var probeSetState = defaultProbeSetState(catalog, false, true);
    if (psc !== undefined) {
        probeSetEnabled = true;
        probeSetState = probeKitToProbeFormState(probeSetState, psc, catalog, false, undefined, undefined)[0];
    }
    // amp set
    var ampEnabled = false;
    var ampState = defaultAmpState(catalog);
    if (amp !== undefined) {
        ampEnabled = true;
        ampState = __assign(__assign({}, ampState), { scale: amp.amplifierScale.slides });
        if ((chromogenComponent === null || chromogenComponent === void 0 ? void 0 : chromogenComponent.chromogen) !== undefined) {
            ampState = __assign(__assign({}, ampState), { chromogen: chromogenComponent.chromogen });
        }
    }
    // buffer set
    var buffersEnabled = false;
    var bufferState = defaultBufferState(catalog, false, true);
    if (manualBuf !== undefined) {
        buffersEnabled = true;
        bufferState = __assign(__assign({}, bufferState), { amp: manualBuf.amp, hybridization: manualBuf.hybridization, wash: manualBuf.wash, goldWash: manualBuf.goldWash, goldAmpWash: manualBuf.goldAmpWash, proAmpWash: manualBuf.proAmpWash });
    }
    var sampleTypeFormState = {
        sampleType: (_b = catalog.goldFishBuffer.sampleTypes.find(function (t) { return t.id === bundles.sampleType.id; })) !== null && _b !== void 0 ? _b : catalog.goldFishBuffer.defaultSampleType
    };
    return {
        ampEnabled: ampEnabled,
        ampState: ampState,
        buffersEnabled: buffersEnabled,
        bufferState: bufferState,
        comment: bundles.comment,
        errors: [],
        price: undefined,
        priceLoading: false,
        probeSetEnabled: probeSetEnabled,
        probeSetState: probeSetState,
        sampleTypeFormState: sampleTypeFormState
    };
};
//# sourceMappingURL=ManualProKitToConsumerFormState.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/bundle-of-kits/ManualProKitToConsumerFormState.js
// module id = 574
// module chunks = 0